// Shared "does this department have a parent?" test.
//
// Task 24468: the obvious `if (!parentId)` is wrong here. The API returns
// integer columns as STRINGS, so a top-level department can arrive as
// Parent___OrganisationDepartmentHierarchy_Id: "0" — and "0" is TRUTHY in
// JavaScript. The Parent Department column therefore skipped its "Top level"
// badge, looked up department 0, found nothing, and rendered "#0"; the Topology
// tab took the same value as a missing parent and badged it "Orphaned".
//
// Both bugs are the same line written twice, so the test lives here once.

/**
 * The parent id as a comparable string, or null when there is no parent.
 * Treats null, undefined, "", 0 and "0" alike.
 */
export const parentIdOf = (department) => {
  const raw = department?.Parent___OrganisationDepartmentHierarchy_Id;
  if (raw === null || raw === undefined) return null;
  const key = String(raw).trim();
  if (key === "" || key === "0") return null;
  return key;
};

export const hasParent = (department) => parentIdOf(department) !== null;

export default parentIdOf;
